import { DEFAULT_CONFIG } from './constants';

function configKey(userId) {
    return userId ? `gymcard_timer_config_u${userId}` : 'gymcard_timer_config';
}

function presetsKey(userId) {
    return userId ? `gymcard_timer_presets_u${userId}` : 'gymcard_timer_presets';
}

export function loadConfig(userId) {
    try {
        const raw = localStorage.getItem(configKey(userId));
        if (!raw) return { ...DEFAULT_CONFIG };
        const parsed = JSON.parse(raw);
        return {
            ...DEFAULT_CONFIG,
            ...parsed,
            sounds: { ...DEFAULT_CONFIG.sounds, ...parsed?.sounds },
            colors: { ...DEFAULT_CONFIG.colors, ...parsed?.colors },
        };
    } catch {
        return { ...DEFAULT_CONFIG };
    }
}

export function saveConfig(config, userId) {
    try {
        localStorage.setItem(configKey(userId), JSON.stringify(config));
    } catch {
        // ignore
    }
}

export function loadPresets(userId) {
    try {
        const raw = localStorage.getItem(presetsKey(userId));
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
    } catch {
        return [];
    }
}

export function savePresets(presets, userId) {
    try {
        localStorage.setItem(presetsKey(userId), JSON.stringify(presets));
    } catch {
        // ignore
    }
}
